import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-encash-sanction-form',
  templateUrl: './leave-encash-sanction-form.component.html',
  styleUrls: ['./leave-encash-sanction-form.component.css']
})
export class LeaveEncashSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/leave-encash-sanction/leave-encash-sanction-form/leave-encash-sanction-form.component.ts